import { combineReducers } from 'redux';
import * as RequestStatus from 'ContentUtils/constants/RequestStatus';
import { CUSTOM_FONTS_BY_ASSET_FETCH_FONTS, CUSTOM_FONTS_FETCH_FONT, CUSTOM_FONTS_FETCH_FONTS, GOOGLE_FONTS_CLEAR, GOOGLE_FONTS_FETCH_COMMON_FONTS, GOOGLE_FONTS_FETCH_FONT, GOOGLE_FONTS_FETCH_FONTS, SELECT_CUSTOM_FONT, SELECT_GOOGLE_FONT, BRAND_FONTS_FETCH_FONTS } from 'ContentData/actions/ActionTypes';
import { createSimpleRequestStatusReducer } from 'ContentData/helpers/reduxHelpers';
import { FontSetsApiToValue } from 'ContentUtils/constants/Fonts';
import { FONT_FORMAT_LIST as SYSTEM_FONTS } from 'ContentUtils/constants/Fonts';
const fonts = (state = {}, action) => {
  switch (action.type) {
    case GOOGLE_FONTS_FETCH_FONTS:
      {
        const {
          response
        } = action;
        if (!(response && response.results)) return state;
        return response.results.reduce((hash, font) => {
          hash[font.family] = font;
          return hash;
        }, Object.assign({}, state));
      }
    case GOOGLE_FONTS_FETCH_FONT:
      {
        const {
          response
        } = action;
        if (!(response && response.family)) return state;
        return Object.assign({}, state, {
          [response.family]: response
        });
      }
    case GOOGLE_FONTS_CLEAR:
      {
        if (Object.keys(state).length) return {};
        return state;
      }
    default:
      return state;
  }
};
const googleFontsPagination = (state = {}, action) => {
  switch (action.type) {
    case GOOGLE_FONTS_FETCH_FONTS:
      {
        const {
          response
        } = action;
        if (!response) return state;
        const {
          hasMore,
          offset,
          total
        } = response;
        return {
          hasMore,
          offset,
          total
        };
      }
    default:
      return state;
  }
};
const selectedFonts = (state = {}, action) => {
  switch (action.type) {
    case GOOGLE_FONTS_FETCH_FONT:
      {
        const {
          response
        } = action;
        if (!response) return state;
        return Object.assign({}, state, {
          [response.family]: response
        });
      }
    case SELECT_GOOGLE_FONT:
      {
        const {
          font
        } = action;
        const fontName = 'family' in font ? font.family : font.name;
        return Object.assign({}, state, {
          [fontName]: font
        });
      }
    default:
      return state;
  }
};
const commonFonts = (state = [], action) => {
  switch (action.type) {
    case GOOGLE_FONTS_FETCH_COMMON_FONTS:
      {
        const {
          response
        } = action;
        if (!(response && response.results)) return state;
        return response.results;
      }
    default:
      return state;
  }
};
const customFontsByAsset = (state = {}, action) => {
  switch (action.type) {
    case CUSTOM_FONTS_BY_ASSET_FETCH_FONTS:
      {
        const {
          response,
          options
        } = action;
        const {
          path
        } = options || {};
        if (!(response && response.length && path)) return state;
        const fontsObj = response.reduce((hash, font) => {
          hash[font.family] = font;
          return hash;
        }, Object.assign({}, state[path]));
        return Object.assign({}, state, {
          [path]: fontsObj
        });
      }
    default:
      return state;
  }
};
const customFontsByAssetRequestStatus = (state = {}, action) => {
  switch (action.type) {
    case CUSTOM_FONTS_BY_ASSET_FETCH_FONTS:
      {
        const {
          error,
          options,
          response
        } = action;
        const {
          path
        } = options || {};
        if (!path) return state;
        let status = RequestStatus.PENDING;
        if (response) status = RequestStatus.SUCCEEDED;
        if (error) status = RequestStatus.FAILED;
        return Object.assign({}, state, {
          [path]: status
        });
      }
    default:
      return state;
  }
};
const customFonts = (state = {}, action) => {
  switch (action.type) {
    case CUSTOM_FONTS_FETCH_FONTS:
      {
        const {
          response
        } = action;
        if (!response) return state;
        return response.reduce((hash, font) => {
          hash[font.name] = font;
          return hash;
        }, {});
      }
    default:
      return state;
  }
};
const selectedCustomFonts = (state = {}, action) => {
  switch (action.type) {
    case CUSTOM_FONTS_FETCH_FONT:
      {
        const {
          response
        } = action;
        if (!response) return state;
        return Object.assign({}, state, {
          [response.name]: response
        });
      }
    case CUSTOM_FONTS_FETCH_FONTS:
      {
        var _options;
        const {
          response
        } = action;
        const selectedFontName = (_options = action.options) === null || _options === void 0 ? void 0 : _options.selectedFontName;
        if (!response || !selectedFontName) return state;
        const selectedFont = response.find(font => font.name === selectedFontName);
        return Object.assign({}, state, {
          [selectedFontName]: selectedFont
        });
      }
    case CUSTOM_FONTS_BY_ASSET_FETCH_FONTS:
      {
        const {
          response
        } = action;
        if (!(response && response.length)) return state;
        return response.reduce((hash, font) => {
          hash[font.family] = font;
          return hash;
        }, Object.assign({}, state));
      }
    case SELECT_CUSTOM_FONT:
      {
        const {
          font
        } = action;
        const fontName = 'family' in font ? font.family : font.name;
        return Object.assign({}, state, {
          [fontName]: font
        });
      }
    default:
      return state;
  }
};
const brandFonts = (state = [], action) => {
  switch (action.type) {
    case BRAND_FONTS_FETCH_FONTS:
      {
        const {
          response
        } = action;
        if (!response) return state;
        const formattedFonts = response.map(font => {
          const {
            fontSet: fontSetFromApi,
            name
          } = font;
          const fontSet = FontSetsApiToValue[fontSetFromApi];
          const optionText = Object.keys(SYSTEM_FONTS).find(key => SYSTEM_FONTS[key] === name);
          return Object.assign({}, font, {
            fontSet,
            optionText
          });
        });
        return formattedFonts;
      }
    default:
      return state;
  }
};
export default combineReducers({
  fonts,
  googleFontsPagination,
  googleFontsRequestStatus: createSimpleRequestStatusReducer(GOOGLE_FONTS_FETCH_FONTS),
  selectedCustomFonts,
  selectedFonts,
  commonFonts,
  commonFontsRequestStatus: createSimpleRequestStatusReducer(GOOGLE_FONTS_FETCH_COMMON_FONTS),
  customFontsByAsset,
  customFontsByAssetRequestStatus,
  customFonts,
  customFontsRequestStatus: createSimpleRequestStatusReducer(CUSTOM_FONTS_FETCH_FONTS),
  brandFonts,
  brandFontsRequestStatus: createSimpleRequestStatusReducer(BRAND_FONTS_FETCH_FONTS)
});